import { Component, OnInit, inject } from '@angular/core';
import { ReportGeneratorService } from '@modules/report-generator/report-generator.service';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { createState } from '@shared/helpers/create-state.helper';
import { GenerationProgress } from '@modules/report-generator/interfaces';

@Component({
  selector: 'app-generate-report-dialog',
  templateUrl: './generate-report-dialog.component.html',
  styleUrls: ['./generate-report-dialog.component.scss']
})
export class GenerateReportDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<GenerateReportDialogComponent>);
  private readonly reportGeneratorService = inject(ReportGeneratorService);

  progress$ = this.reportGeneratorService.progress$;
  progressValue = createState<number>(0);

  ngOnInit(): void {
    this.setupProgress();
  }

  getPageIndices(totalPages: number): number[] {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  getProgressBarMode(pageIndex: number, currentPage: number, status: string): 'determinate' | 'indeterminate' {
    if (status === 'completed') {
      return 'determinate'
    }
    return pageIndex === currentPage ? 'indeterminate' : 'determinate';
  }

  getProgressBarValue(pageIndex: number, currentPage: number, status: string): number {
    if (status === 'completed') {
      return 100
    }
    return pageIndex < currentPage ? 100 : 0;
  }

  getSanitizedErrorMessage(progress: GenerationProgress): string {
    const message = progress.errorMessage ?? ''
    if (message) {
      return message.replace(/^Error:\s*/, '')
    } else {
      return ''
    }
  }

  private setupProgress(): void {
    this.progress$.subscribe({
      next: progress => {
        this.progressValue.set(progress.totalPages ? progress.currentPage / progress.totalPages * 100 : 0);
        
        if (progress.status === 'completed') {
          setTimeout(() => this.dialogRef.close(), 2000);
        }
      }
    });
  }
}
